// extracted by mini-css-extract-plugin
export default {"userCards":"Cards_userCards__vyN7j","cardWrapper":"Cards_cardWrapper__gBrc+","deleteBtn":"Cards_deleteBtn__OmIx7"};